module.exports = __webpack_public_path__ + "img/marquee-rivoneed.d64630e7.webp";